import { gql } from 'graphql-tag'

/**
 * CWA reads only the terms state, from an unaliased `getConsumer` root field.
 *
 * Not converged on the shared `GET_CONSUMER`: that one aliases to `consumer` and
 * pulls the full `ConsumerFields` fragment, which would move the response path
 * and put email/name/phone into the cache of an app running session recording.
 * Only the operation name gains the `CWA` suffix — codegen requires unique
 * operation names across the glob. See CBP-3932.
 */
export const GET_CONSUMER_CWA = gql`
  query getConsumerCWA {
    getConsumer {
      agreedToTermsAndConditions
      latestTermsVersionAgreedTo
    }
  }
`
